import { values, forEach, includes } from 'ramda';
import s from './HostStyles.module.scss';
import { PoiList } from '../../components';
import data from './data/cached-sea-pois.json';

const poidata = values(data);
forEach(poi => {
    poi.uuid = poi.id;
    if (includes(poi.uuid, ['2', '20', '22'])) {
        poi.id = `#${poi.id}`;
    }
}, poidata);

const PoiListEditor = () => (
    <div className={s.editor}>
        <PoiList poisToRender={poidata} />
    </div>
);

export default PoiListEditor;
